import React from 'react'

const Loader = () => {
    return (
        <div className="flexbox">
            <div className='page-loader'>
                <div className="hm-spinner"></div>
            </div>
        </div>
    )
}

export default Loader